export type BookingDraftInput = {
  firstName?: string
  dayLabel: string
  timeLabel: string
  providerName?: string
}

/** First word of a contact name, or undefined when there is nothing usable. */
export function firstNameOf(name: string | undefined): string | undefined {
  const first = name?.trim().split(/\s+/)[0]
  return first ? first : undefined
}

/**
 * Literal, fully resolved confirmation copy. Returns an empty string when the
 * appointment is not describable, so a caller can decide to write no draft at
 * all rather than push half a sentence into the composer.
 */
export function buildBookingDraft({ firstName, dayLabel, timeLabel, providerName }: BookingDraftInput): string {
  if (!dayLabel || !timeLabel) return ``
  const opening = firstName ? `Hi ${firstName}, you’re all set` : `You’re all set`
  const provider = providerName ? ` with ${providerName}` : ``
  return `${opening} for ${dayLabel} at ${timeLabel}${provider}. Reply here if you need to change it.`
}
